import React from 'react'

import { ReviewAnswer, HeadingLarge, HeadingMedium, MetaText } from '@pb/components'
import {
  isArketBrand,
  isMonkiBrand,
  getLabelFromStorage,
  isCosBrand,
  isOtherStoriesBrand,
} from '@pb/utils'
import cn from 'classnames'

import styles from '../ProductDetail.scss'

export const Dimensions = ({
  data,
  handleDimensionClick,
  selectedDimensionValues,
}): React.ReactElement | null => {
  const dimensions = data.catalogItem.dimensions !== null ? data.catalogItem.dimensions : null
  let sizeAndFitLabel = getLabelFromStorage('profile.unreviewedproducts.review.page.size.and.fit')
  sizeAndFitLabel = isOtherStoriesBrand ? sizeAndFitLabel.toLowerCase() : sizeAndFitLabel

  const {
    progressBarWrapperClassName = undefined,
    progressBarLabelClassName = undefined,
    progressBarListItemClassName = undefined,
  } = isArketBrand
    ? {
        progressBarWrapperClassName: styles.progressBarWrapperClassName,
      }
    : isCosBrand
    ? {
        progressBarLabelClassName: styles.progressBarLabelClassName,
        progressBarListItemClassName: styles.progressBarListItemClassName,
      }
    : {}

  if (dimensions && dimensions.length > 0) {
    const dimensionsDOM = dimensions.map((dimension) => {
      return (
        <ReviewAnswer
          key={dimension.label}
          id={dimension.label}
          scale={{
            label: dimension.label,
            values: dimension.values
              .sort((a, b) => a.sortOrder - b.sortOrder)
              .map((value) => value.label),
            percentage: 50,
          }}
          handleSelectScale={handleDimensionClick}
          selectedDimensionValue={selectedDimensionValues[dimension.label] || null}
          progressBarWrapperClassName={progressBarWrapperClassName}
          progressBarLabelClassName={progressBarLabelClassName}
          progressBarListItemClassName={progressBarListItemClassName}
        />
      )
    })

    return (
      <div
        className={cn(
          styles.reviewAnswersContainer,
          isMonkiBrand && styles.reviewAnswersContainerMonkiStyle,
          isCosBrand && styles.reviewAnswerLabel,
        )}
      >
        {isMonkiBrand ? (
          <HeadingLarge Tag="h2">{sizeAndFitLabel}</HeadingLarge>
        ) : isCosBrand ? (
          <MetaText Tag="h2" className={cn(styles.upperCase, styles.dimensionsHeader)}>
            {sizeAndFitLabel}
          </MetaText>
        ) : (
          <HeadingMedium
            Tag="h2"
            className={cn(!isArketBrand && styles.capitalize, isArketBrand && styles.borderHeader)}
          >
            {sizeAndFitLabel}
          </HeadingMedium>
        )}
        {/* Preheading below will be enabled when the hybris label is available in production */}
        {/* {isCosBrand &&  (
          <BodyText meta Tag="p" className={cn(styles.baseTextMeta, styles.dimensionsPreHeading)}>
            {getLabelFromStorage('profile.unreviewedproducts.review.page.dimension.preheading')}
          </BodyText>
        )} */}
        {dimensionsDOM}
      </div>
    )
  }

  return null
}
